import {SET_SHOW_LEAVE_MODAL} from '~/CreateFabricInvitation/reducers/modals/constants';

export const setShowLeaveModal = (show) => ({
  type: SET_SHOW_LEAVE_MODAL,
  payload: show,
});
